export const CountriesJSON = [
  {
    "Country": "Afghanistan",
    "Alpha-2 code": "AF",
    "Alpha-3 code": "AFG",
    "Numeric": "004"
  },
  {
    "Country": "Albania",
    "Alpha-2 code": "AL",
    "Alpha-3 code": "ALB",
    "Numeric": "008"
  },
  {
    "Country": "Algeria",
    "Alpha-2 code": "DZ",
    "Alpha-3 code": "DZA",
    "Numeric": "012"
  },
  {
    "Country": "American Samoa",
    "Alpha-2 code": "AS",
    "Alpha-3 code": "ASM",
    "Numeric": "016"
  },
  {
    "Country": "Andorra",
    "Alpha-2 code": "AD",
    "Alpha-3 code": "AND",
    "Numeric": "020"
  },
  {
    "Country": "Angola",
    "Alpha-2 code": "AO",
    "Alpha-3 code": "AGO",
    "Numeric": "024"
  },
  {
    "Country": "Anguilla",
    "Alpha-2 code": "AI",
    "Alpha-3 code": "AIA",
    "Numeric": "660"
  },
  {
    "Country": "Antarctica",
    "Alpha-2 code": "AQ",
    "Alpha-3 code": "ATA",
    "Numeric": "010"
  },
  {
    "Country": "Antigua and Barbuda",
    "Alpha-2 code": "AG",
    "Alpha-3 code": "ATG",
    "Numeric": "028"
  },
  {
    "Country": "Argentina",
    "Alpha-2 code": "AR",
    "Alpha-3 code": "ARG",
    "Numeric": "032"
  },
  {
    "Country": "Armenia",
    "Alpha-2 code": "AM",
    "Alpha-3 code": "ARM",
    "Numeric": "051"
  },
  {
    "Country": "Aruba",
    "Alpha-2 code": "AW",
    "Alpha-3 code": "ABW",
    "Numeric": "533"
  },
  {
    "Country": "Australia",
    "Alpha-2 code": "AU",
    "Alpha-3 code": "AUS",
    "Numeric": "036"
  },
  {
    "Country": "Austria",
    "Alpha-2 code": "AT",
    "Alpha-3 code": "AUT",
    "Numeric": "040"
  },
  {
    "Country": "Azerbaijan",
    "Alpha-2 code": "AZ",
    "Alpha-3 code": "AZE",
    "Numeric": "031"
  },
  {
    "Country": "Bahamas",
    "Alpha-2 code": "BS",
    "Alpha-3 code": "BHS",
    "Numeric": "044"
  },
  {
    "Country": "Bahrain",
    "Alpha-2 code": "BH",
    "Alpha-3 code": "BHR",
    "Numeric": "048"
  },
  {
    "Country": "Bangladesh",
    "Alpha-2 code": "BD",
    "Alpha-3 code": "BGD",
    "Numeric": "050"
  },
  {
    "Country": "Barbados",
    "Alpha-2 code": "BB",
    "Alpha-3 code": "BRB",
    "Numeric": "052"
  },
  {
    "Country": "Belarus",
    "Alpha-2 code": "BY",
    "Alpha-3 code": "BLR",
    "Numeric": "112"
  },
  {
    "Country": "Belgium",
    "Alpha-2 code": "BE",
    "Alpha-3 code": "BEL",
    "Numeric": "056"
  },
  {
    "Country": "Belize",
    "Alpha-2 code": "BZ",
    "Alpha-3 code": "BLZ",
    "Numeric": "084"
  },
  {
    "Country": "Benin",
    "Alpha-2 code": "BJ",
    "Alpha-3 code": "BEN",
    "Numeric": "204"
  },
  {
    "Country": "Bermuda",
    "Alpha-2 code": "BM",
    "Alpha-3 code": "BMU",
    "Numeric": "060"
  },
  {
    "Country": "Bhutan",
    "Alpha-2 code": "BT",
    "Alpha-3 code": "BTN",
    "Numeric": "064"
  },
  {
    "Country": "Bolivia",
    "Alpha-2 code": "BO",
    "Alpha-3 code": "BOL",
    "Numeric": "068"
  },
  {
    "Country": "Bonaire",
    "Alpha-2 code": "BQ",
    "Alpha-3 code": "BES",
    "Numeric": "535"
  },
  {
    "Country": "Bosnia and Herzegovina",
    "Alpha-2 code": "BA",
    "Alpha-3 code": "BIH",
    "Numeric": "070"
  },
  {
    "Country": "Botswana",
    "Alpha-2 code": "BW",
    "Alpha-3 code": "BWA",
    "Numeric": "072"
  },
  {
    "Country": "Bouvet Island",
    "Alpha-2 code": "BV",
    "Alpha-3 code": "BVT",
    "Numeric": "074"
  },
  {
    "Country": "Brazil",
    "Alpha-2 code": "BR",
    "Alpha-3 code": "BRA",
    "Numeric": "076"
  },
  {
    "Country": "British Indian Ocean Territory",
    "Alpha-2 code": "IO",
    "Alpha-3 code": "IOT",
    "Numeric": "086"
  },
  {
    "Country": "British Virgin Islands",
    "Alpha-2 code": "VG",
    "Alpha-3 code": "VGB",
    "Numeric": "092"
  },
  {
    "Country": "Brunei Darussalam",
    "Alpha-2 code": "BN",
    "Alpha-3 code": "BRN",
    "Numeric": "096"
  },
  {
    "Country": "Bulgaria",
    "Alpha-2 code": "BG",
    "Alpha-3 code": "BGR",
    "Numeric": "100"
  },
  {
    "Country": "Burkina Faso",
    "Alpha-2 code": "BF",
    "Alpha-3 code": "BFA",
    "Numeric": "854"
  },
  {
    "Country": "Burundi",
    "Alpha-2 code": "BI",
    "Alpha-3 code": "BDI",
    "Numeric": "108"
  },
  {
    "Country": "Cabo Verde",
    "Alpha-2 code": "CV",
    "Alpha-3 code": "CPV",
    "Numeric": "132"
  },
  {
    "Country": "Cambodia",
    "Alpha-2 code": "KH",
    "Alpha-3 code": "KHM",
    "Numeric": "116"
  },
  {
    "Country": "Cameroon",
    "Alpha-2 code": "CM",
    "Alpha-3 code": "CMR",
    "Numeric": "120"
  },
  {
    "Country": "Canada",
    "Alpha-2 code": "CA",
    "Alpha-3 code": "CAN",
    "Numeric": "124"
  },
  {
    "Country": "Cayman Islands",
    "Alpha-2 code": "KY",
    "Alpha-3 code": "CYM",
    "Numeric": "136"
  },
  {
    "Country": "Central African Republic",
    "Alpha-2 code": "CF",
    "Alpha-3 code": "CAF",
    "Numeric": "140"
  },
  {
    "Country": "Chad",
    "Alpha-2 code": "TD",
    "Alpha-3 code": "TCD",
    "Numeric": "148"
  },
  {
    "Country": "Chile",
    "Alpha-2 code": "CL",
    "Alpha-3 code": "CHL",
    "Numeric": "152"
  },
  {
    "Country": "China",
    "Alpha-2 code": "CN",
    "Alpha-3 code": "CHN",
    "Numeric": "156"
  },
  {
    "Country": "Christmas Island (Australia)",
    "Alpha-2 code": "CX",
    "Alpha-3 code": "CXR",
    "Numeric": "162"
  },
  {
    "Country": "Cocos (Keeling) Islands (Australia)",
    "Alpha-2 code": "CC",
    "Alpha-3 code": "CCK",
    "Numeric": "166"
  },
  {
    "Country": "Colombia",
    "Alpha-2 code": "CO",
    "Alpha-3 code": "COL",
    "Numeric": "170"
  },
  {
    "Country": "Comoros",
    "Alpha-2 code": "KM",
    "Alpha-3 code": "COM",
    "Numeric": "174"
  },
  {
    "Country": "Cook Islands (NZ-associated state)",
    "Alpha-2 code": "CK",
    "Alpha-3 code": "COK",
    "Numeric": "184"
  },
  {
    "Country": "Costa Rica",
    "Alpha-2 code": "CR",
    "Alpha-3 code": "CRI",
    "Numeric": "188"
  },
  {
    "Country": "Croatia",
    "Alpha-2 code": "HR",
    "Alpha-3 code": "HRV",
    "Numeric": "191"
  },
  {
    "Country": "Cuba",
    "Alpha-2 code": "CU",
    "Alpha-3 code": "CUB",
    "Numeric": "192"
  },
  {
    "Country": "Curaçao",
    "Alpha-2 code": "CW",
    "Alpha-3 code": "CUW",
    "Numeric": "531"
  },
  {
    "Country": "Cyprus",
    "Alpha-2 code": "CY",
    "Alpha-3 code": "CYP",
    "Numeric": "196"
  },
  {
    "Country": "Czechia",
    "Alpha-2 code": "CZ",
    "Alpha-3 code": "CZE",
    "Numeric": "203"
  },
  {
    "Country": "Democratic Republic of the Congo",
    "Alpha-2 code": "CD",
    "Alpha-3 code": "COD",
    "Numeric": "180"
  },
  {
    "Country": "Denmark",
    "Alpha-2 code": "DK",
    "Alpha-3 code": "DNK",
    "Numeric": "208"
  },
  {
    "Country": "Djibouti",
    "Alpha-2 code": "DJ",
    "Alpha-3 code": "DJI",
    "Numeric": "262"
  },
  {
    "Country": "Dominica",
    "Alpha-2 code": "DM",
    "Alpha-3 code": "DMA",
    "Numeric": "212"
  },
  {
    "Country": "Dominican Republic",
    "Alpha-2 code": "DO",
    "Alpha-3 code": "DOM",
    "Numeric": "214"
  },
  {
    "Country": "Ecuador",
    "Alpha-2 code": "EC",
    "Alpha-3 code": "ECU",
    "Numeric": "218"
  },
  {
    "Country": "Egypt",
    "Alpha-2 code": "EG",
    "Alpha-3 code": "EGY",
    "Numeric": "818"
  },
  {
    "Country": "El Salvador",
    "Alpha-2 code": "SV",
    "Alpha-3 code": "SLV",
    "Numeric": "222"
  },
  {
    "Country": "Equatorial Guinea",
    "Alpha-2 code": "GQ",
    "Alpha-3 code": "GNQ",
    "Numeric": "226"
  },
  {
    "Country": "Eritrea",
    "Alpha-2 code": "ER",
    "Alpha-3 code": "ERI",
    "Numeric": "232"
  },
  {
    "Country": "Estonia",
    "Alpha-2 code": "EE",
    "Alpha-3 code": "EST",
    "Numeric": "233"
  },
  {
    "Country": "Eswatini",
    "Alpha-2 code": "SZ",
    "Alpha-3 code": "SWZ",
    "Numeric": "748"
  },
  {
    "Country": "Ethiopia",
    "Alpha-2 code": "ET",
    "Alpha-3 code": "ETH",
    "Numeric": "231"
  },
  {
    "Country": "Falkland Islands",
    "Alpha-2 code": "FK",
    "Alpha-3 code": "FLK",
    "Numeric": "238"
  },
  {
    "Country": "Faroe Islands",
    "Alpha-2 code": "FO",
    "Alpha-3 code": "FRO",
    "Numeric": "234"
  },
  {
    "Country": "Fiji",
    "Alpha-2 code": "FJ",
    "Alpha-3 code": "FJI",
    "Numeric": "242"
  },
  {
    "Country": "Finland",
    "Alpha-2 code": "FI",
    "Alpha-3 code": "FIN",
    "Numeric": "246"
  },
  {
    "Country": "France",
    "Alpha-2 code": "FR",
    "Alpha-3 code": "FRA",
    "Numeric": "250"
  },
  {
    "Country": "French Guiana",
    "Alpha-2 code": "GF",
    "Alpha-3 code": "GUF",
    "Numeric": "254"
  },
  {
    "Country": "French Polynesia",
    "Alpha-2 code": "PF",
    "Alpha-3 code": "PYF",
    "Numeric": "258"
  },
  {
    "Country": "French Southern and Antarctic Lands",
    "Alpha-2 code": "TF",
    "Alpha-3 code": "ATF",
    "Numeric": "260"
  },
  {
    "Country": "Gabon",
    "Alpha-2 code": "GA",
    "Alpha-3 code": "GAB",
    "Numeric": "266"
  },
  {
    "Country": "Gambia",
    "Alpha-2 code": "GM",
    "Alpha-3 code": "GMB",
    "Numeric": "270"
  },
  {
    "Country": "Georgia",
    "Alpha-2 code": "GE",
    "Alpha-3 code": "GEO",
    "Numeric": "268"
  },
  {
    "Country": "Germany",
    "Alpha-2 code": "DE",
    "Alpha-3 code": "DEU",
    "Numeric": "276"
  },
  {
    "Country": "Ghana",
    "Alpha-2 code": "GH",
    "Alpha-3 code": "GHA",
    "Numeric": "288"
  },
  {
    "Country": "Gibraltar",
    "Alpha-2 code": "GI",
    "Alpha-3 code": "GIB",
    "Numeric": "292"
  },
  {
    "Country": "Greece",
    "Alpha-2 code": "GR",
    "Alpha-3 code": "GRC",
    "Numeric": "300"
  },
  {
    "Country": "Greenland",
    "Alpha-2 code": "GL",
    "Alpha-3 code": "GRL",
    "Numeric": "304"
  },
  {
    "Country": "Grenada",
    "Alpha-2 code": "GD",
    "Alpha-3 code": "GRD",
    "Numeric": "308"
  },
  {
    "Country": "Guadeloupe",
    "Alpha-2 code": "GP",
    "Alpha-3 code": "GLP",
    "Numeric": "312"
  },
  {
    "Country": "Guam",
    "Alpha-2 code": "GU",
    "Alpha-3 code": "GUM",
    "Numeric": "316"
  },
  {
    "Country": "Guatemala",
    "Alpha-2 code": "GT",
    "Alpha-3 code": "GTM",
    "Numeric": "320"
  },
  {
    "Country": "Guernsey",
    "Alpha-2 code": "GG",
    "Alpha-3 code": "GGY",
    "Numeric": "831"
  },
  {
    "Country": "Guinea",
    "Alpha-2 code": "GN",
    "Alpha-3 code": "GIN",
    "Numeric": "324"
  },
  {
    "Country": "Guinea-Bissau",
    "Alpha-2 code": "GW",
    "Alpha-3 code": "GNB",
    "Numeric": "624"
  },
  {
    "Country": "Guyana",
    "Alpha-2 code": "GY",
    "Alpha-3 code": "GUY",
    "Numeric": "328"
  },
  {
    "Country": "Haiti",
    "Alpha-2 code": "HT",
    "Alpha-3 code": "HTI",
    "Numeric": "332"
  },
  {
    "Country": "Heard Island and McDonald Islands",
    "Alpha-2 code": "HM",
    "Alpha-3 code": "HMD",
    "Numeric": "334"
  },
  {
    "Country": "Honduras",
    "Alpha-2 code": "HN",
    "Alpha-3 code": "HND",
    "Numeric": "340"
  },
  {
    "Country": "Hong Kong",
    "Alpha-2 code": "HK",
    "Alpha-3 code": "HKG",
    "Numeric": "852"
  },
  {
    "Country": "Hungary",
    "Alpha-2 code": "HU",
    "Alpha-3 code": "HUN",
    "Numeric": "348"
  },
  {
    "Country": "Iceland",
    "Alpha-2 code": "IS",
    "Alpha-3 code": "ISL",
    "Numeric": "352"
  },
  {
    "Country": "India",
    "Alpha-2 code": "IN",
    "Alpha-3 code": "IND",
    "Numeric": "356"
  },
  {
    "Country": "Indonesia",
    "Alpha-2 code": "ID",
    "Alpha-3 code": "IDN",
    "Numeric": "360"
  },
  {
    "Country": "Iran",
    "Alpha-2 code": "IR",
    "Alpha-3 code": "IRN",
    "Numeric": "364"
  },
  {
    "Country": "Iraq",
    "Alpha-2 code": "IQ",
    "Alpha-3 code": "IRQ",
    "Numeric": "368"
  },
  {
    "Country": "Ireland",
    "Alpha-2 code": "IE",
    "Alpha-3 code": "IRL",
    "Numeric": "372"
  },
  {
    "Country": "Isle of Man",
    "Alpha-2 code": "IM",
    "Alpha-3 code": "IMN",
    "Numeric": "833"
  },
  {
    "Country": "Israel",
    "Alpha-2 code": "IL",
    "Alpha-3 code": "ISR",
    "Numeric": "376"
  },
  {
    "Country": "Italy",
    "Alpha-2 code": "IT",
    "Alpha-3 code": "ITA",
    "Numeric": "380"
  },
  {
    "Country": "Ivory Coast",
    "Alpha-2 code": "CI",
    "Alpha-3 code": "CIV",
    "Numeric": "384"
  },
  {
    "Country": "Jamaica",
    "Alpha-2 code": "JM",
    "Alpha-3 code": "JAM",
    "Numeric": "388"
  },
  {
    "Country": "Japan",
    "Alpha-2 code": "JP",
    "Alpha-3 code": "JPN",
    "Numeric": "392"
  },
  {
    "Country": "Jersey",
    "Alpha-2 code": "JE",
    "Alpha-3 code": "JEY",
    "Numeric": "832"
  },
  {
    "Country": "Jordan",
    "Alpha-2 code": "JO",
    "Alpha-3 code": "JOR",
    "Numeric": "400"
  },
  {
    "Country": "Kazakhstan",
    "Alpha-2 code": "KZ",
    "Alpha-3 code": "KAZ",
    "Numeric": "398"
  },
  {
    "Country": "Kenya",
    "Alpha-2 code": "KE",
    "Alpha-3 code": "KEN",
    "Numeric": "404"
  },
  {
    "Country": "Kiribati",
    "Alpha-2 code": "KI",
    "Alpha-3 code": "KIR",
    "Numeric": "296"
  },
  {
    "Country": "Kosovo",
    "Alpha-2 code": "XK",
    "Alpha-3 code": "XKX",
    "Numeric": ""
  },
  {
    "Country": "Kuwait",
    "Alpha-2 code": "KW",
    "Alpha-3 code": "KWT",
    "Numeric": "414"
  },
  {
    "Country": "Kyrgyz Republic",
    "Alpha-2 code": "KG",
    "Alpha-3 code": "KGZ",
    "Numeric": "417"
  },
  {
    "Country": "Lao People's Democratic Republic",
    "Alpha-2 code": "LA",
    "Alpha-3 code": "LAO",
    "Numeric": "418"
  },
  {
    "Country": "Latvia",
    "Alpha-2 code": "LV",
    "Alpha-3 code": "LVA",
    "Numeric": "428"
  },
  {
    "Country": "Lebanon",
    "Alpha-2 code": "LB",
    "Alpha-3 code": "LBN",
    "Numeric": "422"
  },
  {
    "Country": "Lesotho",
    "Alpha-2 code": "LS",
    "Alpha-3 code": "LSO",
    "Numeric": "426"
  },
  {
    "Country": "Liberia",
    "Alpha-2 code": "LR",
    "Alpha-3 code": "LBR",
    "Numeric": "430"
  },
  {
    "Country": "Libya",
    "Alpha-2 code": "LY",
    "Alpha-3 code": "LBY",
    "Numeric": "434"
  },
  {
    "Country": "Liechtenstein",
    "Alpha-2 code": "LI",
    "Alpha-3 code": "LIE",
    "Numeric": "438"
  },
  {
    "Country": "Lithuania",
    "Alpha-2 code": "LT",
    "Alpha-3 code": "LTU",
    "Numeric": "440"
  },
  {
    "Country": "Luxembourg",
    "Alpha-2 code": "LU",
    "Alpha-3 code": "LUX",
    "Numeric": "442"
  },
  {
    "Country": "Macao",
    "Alpha-2 code": "MO",
    "Alpha-3 code": "MAC",
    "Numeric": "446"
  },
  {
    "Country": "Macau",
    "Alpha-2 code": "MO",
    "Alpha-3 code": "MAC",
    "Numeric": "446"
  },
  {
    "Country": "Madagascar",
    "Alpha-2 code": "MG",
    "Alpha-3 code": "MDG",
    "Numeric": "450"
  },
  {
    "Country": "Malawi",
    "Alpha-2 code": "MW",
    "Alpha-3 code": "MWI",
    "Numeric": "454"
  },
  {
    "Country": "Malaysia",
    "Alpha-2 code": "MY",
    "Alpha-3 code": "MYS",
    "Numeric": "458"
  },
  {
    "Country": "Maldives",
    "Alpha-2 code": "MV",
    "Alpha-3 code": "MDV",
    "Numeric": "462"
  },
  {
    "Country": "Mali",
    "Alpha-2 code": "ML",
    "Alpha-3 code": "MLI",
    "Numeric": "466"
  },
  {
    "Country": "Malta",
    "Alpha-2 code": "MT",
    "Alpha-3 code": "MLT",
    "Numeric": "470"
  },
  {
    "Country": "Marshall Islands",
    "Alpha-2 code": "MH",
    "Alpha-3 code": "MHL",
    "Numeric": "584"
  },
  {
    "Country": "Martinique",
    "Alpha-2 code": "MQ",
    "Alpha-3 code": "MTQ",
    "Numeric": "474"
  },
  {
    "Country": "Mauritania",
    "Alpha-2 code": "MR",
    "Alpha-3 code": "MRT",
    "Numeric": "478"
  },
  {
    "Country": "Mauritius",
    "Alpha-2 code": "MU",
    "Alpha-3 code": "MUS",
    "Numeric": "480"
  },
  {
    "Country": "Mayotte",
    "Alpha-2 code": "YT",
    "Alpha-3 code": "MYT",
    "Numeric": "175"
  },
  {
    "Country": "Mexico",
    "Alpha-2 code": "MX",
    "Alpha-3 code": "MEX",
    "Numeric": "484"
  },
  {
    "Country": "Micronesia",
    "Alpha-2 code": "FM",
    "Alpha-3 code": "FSM",
    "Numeric": "583"
  },
  {
    "Country": "Moldova",
    "Alpha-2 code": "MD",
    "Alpha-3 code": "MDA",
    "Numeric": "498"
  },
  {
    "Country": "Monaco",
    "Alpha-2 code": "MC",
    "Alpha-3 code": "MCO",
    "Numeric": "492"
  },
  {
    "Country": "Mongolia",
    "Alpha-2 code": "MN",
    "Alpha-3 code": "MNG",
    "Numeric": "496"
  },
  {
    "Country": "Montenegro",
    "Alpha-2 code": "ME",
    "Alpha-3 code": "MNE",
    "Numeric": "499"
  },
  {
    "Country": "Montserrat",
    "Alpha-2 code": "MS",
    "Alpha-3 code": "MSR",
    "Numeric": "500"
  },
  {
    "Country": "Morocco",
    "Alpha-2 code": "MA",
    "Alpha-3 code": "MAR",
    "Numeric": "504"
  },
  {
    "Country": "Mozambique",
    "Alpha-2 code": "MZ",
    "Alpha-3 code": "MOZ",
    "Numeric": "508"
  },
  {
    "Country": "Myanmar",
    "Alpha-2 code": "MM",
    "Alpha-3 code": "MMR",
    "Numeric": "104"
  },
  {
    "Country": "Namibia",
    "Alpha-2 code": "NA",
    "Alpha-3 code": "NAM",
    "Numeric": "516"
  },
  {
    "Country": "Nauru",
    "Alpha-2 code": "NR",
    "Alpha-3 code": "NRU",
    "Numeric": "520"
  },
  {
    "Country": "Nepal",
    "Alpha-2 code": "NP",
    "Alpha-3 code": "NPL",
    "Numeric": "524"
  },
  {
    "Country": "Netherlands",
    "Alpha-2 code": "NL",
    "Alpha-3 code": "NLD",
    "Numeric": "528"
  },
  {
    "Country": "New Caledonia",
    "Alpha-2 code": "NC",
    "Alpha-3 code": "NCL",
    "Numeric": "540"
  },
  {
    "Country": "New Zealand",
    "Alpha-2 code": "NZ",
    "Alpha-3 code": "NZL",
    "Numeric": "554"
  },
  {
    "Country": "Nicaragua",
    "Alpha-2 code": "NI",
    "Alpha-3 code": "NIC",
    "Numeric": "558"
  },
  {
    "Country": "Niger",
    "Alpha-2 code": "NE",
    "Alpha-3 code": "NER",
    "Numeric": "562"
  },
  {
    "Country": "Nigeria",
    "Alpha-2 code": "NG",
    "Alpha-3 code": "NGA",
    "Numeric": "566"
  },
  {
    "Country": "Niue",
    "Alpha-2 code": "NU",
    "Alpha-3 code": "NIU",
    "Numeric": "570"
  },
  {
    "Country": "Norfolk Island",
    "Alpha-2 code": "NF",
    "Alpha-3 code": "NFK",
    "Numeric": "574"
  },
  {
    "Country": "North Macedonia",
    "Alpha-2 code": "MK",
    "Alpha-3 code": "MKD",
    "Numeric": "807"
  },
  {
    "Country": "Northern Ireland",
    "Alpha-2 code": "XI",
    "Alpha-3 code": "GBR",
    "Numeric": "826"
  },
  {
    "Country": "Northern Mariana Islands",
    "Alpha-2 code": "MP",
    "Alpha-3 code": "MNP",
    "Numeric": "580"
  },
  {
    "Country": "Norway",
    "Alpha-2 code": "NO",
    "Alpha-3 code": "NOR",
    "Numeric": "578"
  },
  {
    "Country": "Oman",
    "Alpha-2 code": "OM",
    "Alpha-3 code": "OMN",
    "Numeric": "512"
  },
  {
    "Country": "Pakistan",
    "Alpha-2 code": "PK",
    "Alpha-3 code": "PAK",
    "Numeric": "586"
  },
  {
    "Country": "Palau",
    "Alpha-2 code": "PW",
    "Alpha-3 code": "PLW",
    "Numeric": "585"
  },
  {
    "Country": "Palestine",
    "Alpha-2 code": "PS",
    "Alpha-3 code": "PSE",
    "Numeric": "275"
  },
  {
    "Country": "Panama",
    "Alpha-2 code": "PA",
    "Alpha-3 code": "PAN",
    "Numeric": "591"
  },
  {
    "Country": "Papua New Guinea",
    "Alpha-2 code": "PG",
    "Alpha-3 code": "PNG",
    "Numeric": "598"
  },
  {
    "Country": "Paraguay",
    "Alpha-2 code": "PY",
    "Alpha-3 code": "PRY",
    "Numeric": "600"
  },
  {
    "Country": "Peru",
    "Alpha-2 code": "PE",
    "Alpha-3 code": "PER",
    "Numeric": "604"
  },
  {
    "Country": "Philippines",
    "Alpha-2 code": "PH",
    "Alpha-3 code": "PHL",
    "Numeric": "608"
  },
  {
    "Country": "Pitcairn Islands",
    "Alpha-2 code": "PN",
    "Alpha-3 code": "PCN",
    "Numeric": "612"
  },
  {
    "Country": "Poland",
    "Alpha-2 code": "PL",
    "Alpha-3 code": "POL",
    "Numeric": "616"
  },
  {
    "Country": "Portugal",
    "Alpha-2 code": "PT",
    "Alpha-3 code": "PRT",
    "Numeric": "620"
  },
  {
    "Country": "Puerto Rico",
    "Alpha-2 code": "PR",
    "Alpha-3 code": "PRI",
    "Numeric": "630"
  },
  {
    "Country": "Qatar",
    "Alpha-2 code": "QA",
    "Alpha-3 code": "QAT",
    "Numeric": "634"
  },
  {
    "Country": "Republic of Korea",
    "Alpha-2 code": "KR",
    "Alpha-3 code": "KOR",
    "Numeric": "410"
  },
  {
    "Country": "Republic of the Congo",
    "Alpha-2 code": "CG",
    "Alpha-3 code": "COG",
    "Numeric": "178"
  },
  {
    "Country": "Réunion",
    "Alpha-2 code": "RE",
    "Alpha-3 code": "REU",
    "Numeric": "638"
  },
  {
    "Country": "Romania",
    "Alpha-2 code": "RO",
    "Alpha-3 code": "ROU",
    "Numeric": "642"
  },
  {
    "Country": "Russian Federation",
    "Alpha-2 code": "RU",
    "Alpha-3 code": "RUS",
    "Numeric": "643"
  },
  {
    "Country": "Rwanda",
    "Alpha-2 code": "RW",
    "Alpha-3 code": "RWA",
    "Numeric": "646"
  },
  {
    "Country": "Saba",
    "Alpha-2 code": "BQ",
    "Alpha-3 code": "BES",
    "Numeric": "535"
  },
  {
    "Country": "Saint Barthélemy",
    "Alpha-2 code": "BL",
    "Alpha-3 code": "BLM",
    "Numeric": "652"
  },
  {
    "Country": "Saint Helena",
    "Alpha-2 code": "SH",
    "Alpha-3 code": "SHN",
    "Numeric": "654"
  },
  {
    "Country": "Saint Kitts and Nevis",
    "Alpha-2 code": "KN",
    "Alpha-3 code": "KNA",
    "Numeric": "659"
  },
  {
    "Country": "Saint Lucia",
    "Alpha-2 code": "LC",
    "Alpha-3 code": "LCA",
    "Numeric": "662"
  },
  {
    "Country": "Saint Martin",
    "Alpha-2 code": "MF",
    "Alpha-3 code": "MAF",
    "Numeric": "663"
  },
  {
    "Country": "Saint Pierre and Miquelon",
    "Alpha-2 code": "PM",
    "Alpha-3 code": "SPM",
    "Numeric": "666"
  },
  {
    "Country": "Saint Vincent and the Grenadines",
    "Alpha-2 code": "VC",
    "Alpha-3 code": "VCT",
    "Numeric": "670"
  },
  {
    "Country": "Samoa",
    "Alpha-2 code": "WS",
    "Alpha-3 code": "WSM",
    "Numeric": "882"
  },
  {
    "Country": "San Marino",
    "Alpha-2 code": "SM",
    "Alpha-3 code": "SMR",
    "Numeric": "674"
  },
  {
    "Country": "Sao Tome and Principe",
    "Alpha-2 code": "ST",
    "Alpha-3 code": "STP",
    "Numeric": "678"
  },
  {
    "Country": "Saudi Arabia",
    "Alpha-2 code": "SA",
    "Alpha-3 code": "SAU",
    "Numeric": "682"
  },
  {
    "Country": "Senegal",
    "Alpha-2 code": "SN",
    "Alpha-3 code": "SEN",
    "Numeric": "686"
  },
  {
    "Country": "Serbia",
    "Alpha-2 code": "RS",
    "Alpha-3 code": "SRB",
    "Numeric": "688"
  },
  {
    "Country": "Seychelles",
    "Alpha-2 code": "SC",
    "Alpha-3 code": "SYC",
    "Numeric": "690"
  },
  {
    "Country": "Sierra Leone",
    "Alpha-2 code": "SL",
    "Alpha-3 code": "SLE",
    "Numeric": "694"
  },
  {
    "Country": "Singapore",
    "Alpha-2 code": "SG",
    "Alpha-3 code": "SGP",
    "Numeric": "702"
  },
  {
    "Country": "Sint Eustatius",
    "Alpha-2 code": "BQ",
    "Alpha-3 code": "BES",
    "Numeric": "535"
  },
  {
    "Country": "Sint Maarten",
    "Alpha-2 code": "SX",
    "Alpha-3 code": "SXM",
    "Numeric": "534"
  },
  {
    "Country": "Slovakia",
    "Alpha-2 code": "SK",
    "Alpha-3 code": "SVK",
    "Numeric": "703"
  },
  {
    "Country": "Slovenia",
    "Alpha-2 code": "SI",
    "Alpha-3 code": "SVN",
    "Numeric": "705"
  },
  {
    "Country": "Solomon Islands",
    "Alpha-2 code": "SB",
    "Alpha-3 code": "SLB",
    "Numeric": "090"
  },
  {
    "Country": "Somalia",
    "Alpha-2 code": "SO",
    "Alpha-3 code": "SOM",
    "Numeric": "706"
  },
  {
    "Country": "South Africa",
    "Alpha-2 code": "ZA",
    "Alpha-3 code": "ZAF",
    "Numeric": "710"
  },
  {
    "Country": "South Georgia and the South Sandwich Islands",
    "Alpha-2 code": "GS",
    "Alpha-3 code": "SGS",
    "Numeric": "239"
  },
  {
    "Country": "South Sudan",
    "Alpha-2 code": "SS",
    "Alpha-3 code": "SSD",
    "Numeric": "728"
  },
  {
    "Country": "Spain",
    "Alpha-2 code": "ES",
    "Alpha-3 code": "ESP",
    "Numeric": "724"
  },
  {
    "Country": "Sri Lanka",
    "Alpha-2 code": "LK",
    "Alpha-3 code": "LKA",
    "Numeric": "144"
  },
  {
    "Country": "Sudan",
    "Alpha-2 code": "SD",
    "Alpha-3 code": "SDN",
    "Numeric": "729"
  },
  {
    "Country": "Suriname",
    "Alpha-2 code": "SR",
    "Alpha-3 code": "SUR",
    "Numeric": "740"
  },
  {
    "Country": "Svalbard and Jan Mayen",
    "Alpha-2 code": "SJ",
    "Alpha-3 code": "SJM",
    "Numeric": "744"
  },
  {
    "Country": "Sweden",
    "Alpha-2 code": "SE",
    "Alpha-3 code": "SWE",
    "Numeric": "752"
  },
  {
    "Country": "Switzerland",
    "Alpha-2 code": "CH",
    "Alpha-3 code": "CHE",
    "Numeric": "756"
  },
  {
    "Country": "Syria",
    "Alpha-2 code": "SY",
    "Alpha-3 code": "SYR",
    "Numeric": "760"
  },
  {
    "Country": "Taiwan",
    "Alpha-2 code": "TW",
    "Alpha-3 code": "TWN",
    "Numeric": "158"
  },
  {
    "Country": "Tajikistan",
    "Alpha-2 code": "TJ",
    "Alpha-3 code": "TJK",
    "Numeric": "762"
  },
  {
    "Country": "Tanzania",
    "Alpha-2 code": "TZ",
    "Alpha-3 code": "TZA",
    "Numeric": "834"
  },
  {
    "Country": "Thailand",
    "Alpha-2 code": "TH",
    "Alpha-3 code": "THA",
    "Numeric": "764"
  },
  {
    "Country": "Timor-Leste",
    "Alpha-2 code": "TL",
    "Alpha-3 code": "TLS",
    "Numeric": "626"
  },
  {
    "Country": "Togo",
    "Alpha-2 code": "TG",
    "Alpha-3 code": "TGO",
    "Numeric": "768"
  },
  {
    "Country": "Tokelau",
    "Alpha-2 code": "TK",
    "Alpha-3 code": "TKL",
    "Numeric": "772"
  },
  {
    "Country": "Tonga",
    "Alpha-2 code": "TO",
    "Alpha-3 code": "TON",
    "Numeric": "776"
  },
  {
    "Country": "Trinidad and Tobago",
    "Alpha-2 code": "TT",
    "Alpha-3 code": "TTO",
    "Numeric": "780"
  },
  {
    "Country": "Tunisia",
    "Alpha-2 code": "TN",
    "Alpha-3 code": "TUN",
    "Numeric": "788"
  },
  {
    "Country": "Turkey",
    "Alpha-2 code": "TR",
    "Alpha-3 code": "TUR",
    "Numeric": "792"
  },
  {
    "Country": "Turkmenistan",
    "Alpha-2 code": "TM",
    "Alpha-3 code": "TKM",
    "Numeric": "795"
  },
  {
    "Country": "Turks and Caicos Islands",
    "Alpha-2 code": "TC",
    "Alpha-3 code": "TCA",
    "Numeric": "796"
  },
  {
    "Country": "Tuvalu",
    "Alpha-2 code": "TV",
    "Alpha-3 code": "TUV",
    "Numeric": "798"
  },
  {
    "Country": "U.S. Virgin Islands",
    "Alpha-2 code": "VI",
    "Alpha-3 code": "VIR",
    "Numeric": "850"
  },
  {
    "Country": "Uganda",
    "Alpha-2 code": "UG",
    "Alpha-3 code": "UGA",
    "Numeric": "800"
  },
  {
    "Country": "Ukraine",
    "Alpha-2 code": "UA",
    "Alpha-3 code": "UKR",
    "Numeric": "804"
  },
  {
    "Country": "United Arab Emirates",
    "Alpha-2 code": "AE",
    "Alpha-3 code": "ARE",
    "Numeric": "784"
  },
  {
    "Country": "United Kingdom",
    "Alpha-2 code": "GB",
    "Alpha-3 code": "GBR",
    "Numeric": "826"
  },
  {
    "Country": "United States",
    "Alpha-2 code": "US",
    "Alpha-3 code": "USA",
    "Numeric": "840"
  },
  {
    "Country": "Uruguay",
    "Alpha-2 code": "UY",
    "Alpha-3 code": "URY",
    "Numeric": "858"
  },
  {
    "Country": "Uzbekistan",
    "Alpha-2 code": "UZ",
    "Alpha-3 code": "UZB",
    "Numeric": "860"
  },
  {
    "Country": "Vanuatu",
    "Alpha-2 code": "VU",
    "Alpha-3 code": "VUT",
    "Numeric": "548"
  },
  {
    "Country": "Vatican City",
    "Alpha-2 code": "VA",
    "Alpha-3 code": "VAT",
    "Numeric": "336"
  },
  {
    "Country": "Venezuela",
    "Alpha-2 code": "VE",
    "Alpha-3 code": "VEN",
    "Numeric": "862"
  },
  {
    "Country": "Viet Nam",
    "Alpha-2 code": "VN",
    "Alpha-3 code": "VNM",
    "Numeric": "704"
  },
  {
    "Country": "Wallis and Futuna",
    "Alpha-2 code": "WF",
    "Alpha-3 code": "WLF",
    "Numeric": "876"
  },
  {
    "Country": "Western Sahara",
    "Alpha-2 code": "EH",
    "Alpha-3 code": "ESH",
    "Numeric": "732"
  },
  {
    "Country": "Yemen",
    "Alpha-2 code": "YE",
    "Alpha-3 code": "YEM",
    "Numeric": "887"
  },
  {
    "Country": "Zambia",
    "Alpha-2 code": "ZM",
    "Alpha-3 code": "ZMB",
    "Numeric": "894"
  },
  {
    "Country": "Zimbabwe",
    "Alpha-2 code": "ZW",
    "Alpha-3 code": "ZWE",
    "Numeric": "716"
  }
];
